define('ordersDetailAttachmentsCustomerView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'settings',
  'attachmentsView',
  'compositionPickerView',
  'entities/orders'
], function(
  App,
  Module,
  _,
  $,
  Settings,
  AttachmentsView,
  CompositionPickerView
) {
  'use strict';

  Module.exports = AttachmentsView.extend({

    setConfig() {
      return {
        galleryTitle: 'Customer Attachment',
        canCopy: Settings.configValue('order.attachments.showCustomerAttachments') ? true : false,
        copyButton: {
          title: _.i18n('orders.detail.attachments.customer.copy-button.title')
        },
        canApplyToComposition: true,
        canAiEdit: true
      };
    },

    aiEditItem: function(attachment) {
      this.openAiEditChat(this.options.order.get('purchaseOrderId'), attachment);
    },
    
    getPrintAreas: function() {
      return this.printAreasFromOrder(this.options.order);
    },

    fetch: function(first, pageSize) {   
      return this.model.getAttachments(first, pageSize);
    },

    uploadItem: function(file) {   
      return this.model.uploadAttachment(file);
    },

    deleteItem(attachment) {
      return this.model.deleteAttachment(attachment);
    },

    editItem: function(attachment) {
      App.navigate('attachments/attachments/' + this.model.get('secId') + '/' + attachment.get('secId') + '/customer', {trigger: true});
    },

    copyItem: function(attachment) {
      this.model.copyAttachmentToOrder(attachment, this.options.order.get('purchaseOrderId')).done(_.bind(function(newAttachment) {
        var model = App.request('order:model', newAttachment);
        this.options.attachmentsView.orderView.addAttachment(model);
      }, this));
    },

    applyItemToComposition: function(attachment) {
      var order = this.options.order;
      if(!order || !attachment) return;

      CompositionPickerView.open({
        order: order,
        attachmentName: attachment.get('fileName'),
        onPick: function(composition) {
          var fileUid = extractFileUid(attachment.get('fileLink'));
          if(!fileUid) {
            showNotify(_.i18n('attachments.applyToComposition.noFileUid', null,
              'Could not resolve the file UID for this attachment.'), 'danger');
            return;
          }

          showNotify(_.i18n('attachments.applyToComposition.applying', null,
            'Applying image to the selected personalisation…'), 'info');

          order.applyAttachmentToComposition(composition.secId, fileUid, attachment.get('fileName'))
            .done(function() {
              showNotify(_.i18n('attachments.applyToComposition.success', null,
                'Image applied to the selected personalisation.'), 'success');
              if(order.fetch) order.fetch();
            })
            .fail(function() {
              showNotify(_.i18n('attachments.applyToComposition.failed', null,
                'Failed to apply image to the selected personalisation.'), 'danger');
            });
        }
      });
    }
  });

  function showNotify(message, type) {
    if(!$.notify) return;
    $.notify({
      message: message
    }, {
      type: type || 'info',
      placement: { from: 'top', align: 'center' },
      delay: type === 'danger' ? 5000 : 3000
    });
  }

  /**
   * fileLink looks like "files/getfile/<uid>?params=t&action=preview&tokenId=...".
   * We want the bare <uid> portion.
   */
  function extractFileUid(fileLink) {
    if(!fileLink) return null;
    var match = fileLink.match(/getfile\/([^?&/]+)/);
    return match ? match[1] : null;
  }
});

